<template>
    <div class="boxs">
        <div class="title"> 设置密码 </div>
        <div class="input-box m-b-10" :class="{
            error: !!errorText
        }">
            <input v-model="password" type="password"  placeholder="请输入您的新密码">
        </div>
        <div class="input-box m-b-10" :class="{
            error: !!errorText
        }">
            <input v-model="repetPass" type="password"  placeholder="请输入再次确认您的新密码">
        </div>
        <div class="primary-btn" @click="goLogin" style="margin-top:50px;">完成</div>
    </div>
</template>
<script>
    const qs = require('qs');
    export default {
        data(){
            return {
                phone:'',
                password:'',
                repetPass:''
            }
        },
        beforeRouteEnter(to,from,next){
            console.log(from)
            let frompath = from.fullPath;
            if(frompath == '/pwdfindone'){
                next();
            }else{
                next(vm => {
                    vm.$router.replace({path:frompath});
                })
            }
        },
        created(){
            let phone = this.$route.query.phone;
            if (phone && phone.length > 11) {
                this.phone = window.atob(phone);
            }else{
                // this.$router.replace({path:'/pwdfindone'});
            }
        },
        methods:{
            goLogin(){
                if(this.password.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入密码'
                    });
                    return;
                }
                if(this.repetPass != this.password){
                    this.$message({
                        type:'warning',
                        message:'两次密码输入不一致'
                    });
                    return;
                }
                let qdata = {
                    phone:this.phone,
                    password:this.password,
                    repetPass:this.repetPass
                }
                this.axios.post('/wapi/hr/resetPwd',qs.stringify(qdata))
                .then((res)=>{
                    if(res.status*1 == 200){
                        this.$message({
                            type:'success',
                            message:'新密码设置成功，请登录'
                        })
                        setTimeout(()=>{
                            this.$router.push({
                                path:'/yzlogin',
                                query: {
                                    phone:this.phone
                                }
                            })
                        },3000);
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
@import url('../../assets/less/login.less');
</style>


// WEBPACK FOOTER //
// mmzhSteptwo.vue?462093f5